import React from 'react';
import { Box, Snackbar } from '@mui/material';

// Acima disto o texto quebra linha dentro do balão em vez de vazar para fora.
const WRAP_AFTER_CHARS = 60;

const ICON_BY_SEVERITY = {
  error: 'error',
  warning: 'warning',
};

/**
 * Tempo de leitura proporcional ao texto: de 2,2 s a 8 s. Um aviso longo que
 * some em 2 s não foi lido.
 */
export const toastDurationFor = (message) => {
  const length = String(message || '').length;
  return Math.min(8000, Math.max(2200, 2200 + length * 45));
};

/**
 * Toast padrão do Hub360 (top-center).
 * Aceita `toast={{ message, severity }}` ou `message` string.
 * `severity`: `success` (padrão), `error`, `warning` ou `info`.
 */
const AppToast = ({
  toast = null,
  message = null,
  severity = 'success',
  open,
  onClose,
  autoHideDuration = 4000,
}) => {
  const resolvedMessage = toast?.message ?? message;
  const resolvedSeverity = toast?.severity || severity || 'success';
  const isOpen = open !== undefined ? Boolean(open) : Boolean(resolvedMessage);

  return (
    <Snackbar
      open={isOpen}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      {resolvedMessage ? (
        <Box
          className={`app-toast app-toast-${resolvedSeverity}${String(resolvedMessage).length > WRAP_AFTER_CHARS ? ' app-toast-wrap' : ''}`}
          role="status"
          aria-live="polite"
        >
          <span className="material-symbols-rounded app-toast-icon" aria-hidden="true">
            {ICON_BY_SEVERITY[resolvedSeverity] || 'check_circle'}
          </span>
          <span className="app-toast-message">{resolvedMessage}</span>
        </Box>
      ) : null}
    </Snackbar>
  );
};

export default AppToast;
